import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import '../RechargeComponent/txnhistory.css';
import '../MoneyTransferComponent/Subtransaction.css';
import FinxPayLogo from "../../assests/images/finxpay.png";
import { Link } from "react-router-dom";
import moment from "moment";
const httpClient = axios.create();

class TxnHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: '',
            displayErrorMsg: '',
            showModal: false,
            paymentStatus: '',
            transferredAmount: '',
            orderId: '',
            createdOn: '',
            txnSubOrder: ''


        }
    }


    componentDidMount() {


    }
    componentWillUnmount() {
    }


    errorMessageCall = (message) => {
        this.setState({
            displayErrorMsg: message
        })
    }


    moDalPrint = (event, txn) => {
        event.preventDefault();

        this.setState({
            showModal: true,
            paymentStatus: txn.status != null ? txn.status : 'Unknown Status',
            transferredAmount: txn.transaction != null && txn.transaction.amount,
            orderId: txn.id != null ? txn.id : 'Unlnown Id',
            createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),

        })
    }

    printdiv = (event) => {
        event.preventDefault();
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }

    render() {

        return (
            <div id="recenttxn">
                <div class="head">
                    {(this.props.rechargeType != '' && this.props.rechargeType != undefined &&
                        this.props.rechargeType != null) ?
                        <h3>Recent Transactions-{' ' + this.props.rechargeType.substring(0, 1).toUpperCase() + this.props.rechargeType.substring(1, this.props.rechargeType.length).toLowerCase()}</h3> :
                        <h3>Recent Transactions</h3>
                    }

                    <Link to='/recharge-txn'>
                        <button type="button">View All</button>
                    </Link>



                </div>



                <div class="txn-list" id="recntxn">
                    {this.props.rechargeTxnHistory != undefined &&
                        this.props.rechargeTxnHistory != 'error' &&
                        this.props.rechargeTxnHistory != 'loading' &&
                        this.props.rechargeTxnHistory.length > 0 &&
                        this.props.rechargeTxnHistory.slice(0, 6).map((txnOrder, index) => (
                            <div class="txncard grbg" id={"txnhead" + index}>
                                <div class="txn-basic" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
                                    aria-expanded="false" aria-controls={"#txn" + index}>
                                    <div class="txn-type">
                                        <img src={"images/" + txnOrder.transaction.operator.toLowerCase() + ".png"} alt="Airtel" data-toggle="tooltip" title={txnOrder.transaction.operator.toLowerCase()} />
                                        <h5>{this.props.rechargeType.toUpperCase()} - Recharge</h5>
                                        <p>{txnOrder.transaction != null ?
                                            txnOrder.transaction.mobile != null ?
                                                txnOrder.transaction.mobile : txnOrder.transaction.customerId != null ?
                                                    txnOrder.transaction.customerId : 'NA' : 'NA'}</p>
                                    </div>
                                    <div class="txn-no">
                                        <h6>Order ID: {txnOrder.id != null ?
                                            txnOrder.id : 'NA'}</h6>
                                        <p> {txnOrder.createdOn != null ?
                                            moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</p>
                                    </div>
                                    <div class="txn-amount">
                                        <h4>₹ {txnOrder.transaction != null ?
                                            txnOrder.transaction.amount != null ?
                                                parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</h4>
                                        <p class={txnOrder.status != null ? (txnOrder.status == 'FAILED'
                                            || txnOrder.status == 'INTERNAL_FAILURE'
                                            || txnOrder.status == 'SUCCESS_TO_FAILED') ? 'failed'
                                            : (txnOrder.status == 'PENDING'
                                                || txnOrder.status == 'ACCEPTED'
                                                || txnOrder.status == 'PROCESSING'
                                                || txnOrder.status == 'HUNG'
                                            ) ? 'pending'
                                                : (txnOrder.status == 'AUTO_REVERSED'
                                                    || txnOrder.status == 'MANUALLY_REVERSED'
                                                ) ? 'pending'
                                                    : txnOrder.status == 'SUCCESS' ? 'success' :
                                                        'pending'

                                            : 'pending'}>{txnOrder.status != null &&
                                                (txnOrder.status == 'FAILED'
                                                    || txnOrder.status == 'INTERNAL_FAILURE'
                                                    || txnOrder.status == 'SUCCESS_TO_FAILED') ?
                                                'Failed' : (txnOrder.status == 'PENDING'
                                                    || txnOrder.status == 'ACCEPTED'
                                                    || txnOrder.status == 'PROCESSING'
                                                    || txnOrder.status == 'HUNG'
                                                ) ? 'Pending' :
                                                    (txnOrder.status == 'AUTO_REVERSED'
                                                        || txnOrder.status == 'MANUALLY_REVERSED'
                                                    ) ? 'Reversed' :
                                                        txnOrder.status == 'SUCCESS' ? 'Success' :
                                                            txnOrder.status.toUpperCase()}</p>
                                    </div>
                                </div>

                                <div id={"txn" + index} class="accordion-collapse collapse"
                                    aria-labelledby={"txnhead" + index} data-bs-parent="#recntxn" data-parent="#recntxn">
                                    <div class="txn-details">

                                        <div class="txn-no">
                                            <h6>Debited from:</h6>
                                            <p>TA - {this.props.agentInfo.mobile}</p>
                                        </div>

                                        <div class="blnc-amount">
                                            <p>TA Balance</p>
                                            <h5>₹ NA</h5>
                                        </div>
                                    </div>

                                    <div class="subtxn">
                                        <h4>Sub Transactions</h4>
                                        <div class={txnOrder.status == 'SUCCESS' ? "subtxn-success" :
                                            (txnOrder.status == 'FAILED'
                                                || txnOrder.status == 'INTERNAL_FAILURE'
                                                || txnOrder.status == 'SUCCESS_TO_FAILED') ? "subtxn-failed" :
                                                (txnOrder.status == 'PENDING'
                                                    || txnOrder.status == 'ACCEPTED'
                                                    || txnOrder.status == 'PROCESSING'
                                                    || txnOrder.status == 'HUNG'
                                                ) ? "subtxn-pending" :
                                                    (txnOrder.status == 'AUTO_REVERSED'
                                                        || txnOrder.status == 'MANUALLY_REVERSED'
                                                    ) ? "subtxn-pending" :
                                                        "subtxn-pending"}>
                                            <div class="subtxnleft">
                                                <div class="subtxntxt">{txnOrder.status == 'SUCCESS' ? "Successful" :
                                                    (txnOrder.status == 'FAILED'
                                                        || txnOrder.status == 'FAIL'
                                                        || txnOrder.status == 'INTERNAL_FAILURE'
                                                        || txnOrder.status == 'SUCCESS_TO_FAILED') ? "Failed" :
                                                        (txnOrder.status == 'PENDING'
                                                            || txnOrder.status == 'ACCEPTED'
                                                            || txnOrder.status == 'PROCESSING'
                                                            || txnOrder.status == 'HUNG'
                                                        ) ? "Under Process" :
                                                            (txnOrder.status == 'AUTO_REVERSED'
                                                                || txnOrder.status == 'MANUALLY_REVERSED'
                                                            ) ?
                                                                "Reversed" :
                                                                txnOrder.status.toUpperCase()}</div>
                                                <div class="subtxnid">{txnOrder.id != null ?
                                                    txnOrder.id : 'NA'}
                                                    <span> {txnOrder.createdOn != null ?
                                                        moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</span></div>
                                            </div>
                                            <div class="subamunt">₹{txnOrder.transaction != null ?
                                                txnOrder.transaction.amount != null ?
                                                    parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</div>
                                        </div>



                                        <div class="orderdetail1">
                                            <div class="txnhead">Order Details</div>
                                            <div class="odramt">
                                                <p>Order Amount <span>₹ {txnOrder.transaction != null ?
                                                    txnOrder.transaction.amount != null ?
                                                        parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</span></p>
                                                <p>Comission <span>₹ {(txnOrder.status.toLowerCase() != 'failed' && txnOrder.txnDetails != null) ?
                                                    txnOrder.txnDetails.surcharge != null ?
                                                        parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                            </div>
                                            <div class="ttlamt"><p>Total Amount <span>₹ {parseFloat((txnOrder.transaction.amount) -
                                                (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)
                                            }</span></p></div>
                                        </div>

                                        <div class="tnsfrdetail1">
                                            <div class="txnhead">Withdrawal Details</div>
                                            <div class="odramt">
                                                <p>Withdrawal Amount <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
                                                    txnOrder.transaction.amount != null ?
                                                        parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : '0.00'}</span></p>
                                                <p>Comission <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false &&
                                                    txnOrder.txnDetails != null) ?
                                                    txnOrder.txnDetails.surcharge != null ?
                                                        parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                            </div>

                                            <div class="ttlamt"><p>Total Amount <span>₹ {txnOrder.status.toLowerCase().includes('fail') == false ?
                                                parseFloat((txnOrder.transaction.amount) - (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)
                                                : parseFloat(0).toFixed(2)}

                                            </span></p></div>
                                        </div>
                                    </div>

                                    <div class="txn-btn">
                                        {/* <button type="button" class="retry" onClick={e => this.moneyTransfer(e, txnOrder)}>Repeat</button>
                                        {
                                            <button type="button" class="print"
                                                data-bs-toggle="modal"
                                                data-bs-target="#print"
                                                onClick={e => this.moDalPrint(e, txnOrder)}>Print</button>
                                        } */}


                                    </div>


                                </div>
                            </div>
                        ))}
                    {this.props.rechargeTxnHistory == undefined &&
                        <div >
                            No Records found
                        </div>
                    }
                    {this.props.rechargeTxnHistory == 'error' &&
                        <div class='valid-error'>
                            Something went wrong,please try later!
                        </div>
                    }
                    {this.props.rechargeTxnHistory.length == 0 &&
                        <div >
                            No Recent Records found
                        </div>
                    }
                    {this.props.rechargeTxnHistory == 'loading' &&
                        <div >
                            Loading transaction history....
                        </div>
                    }

                </div>

                <div class="modal fade" id="print" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header modhead">
                                <h5 class="modal-title">Money Transfer Reciept</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="printtable">
                                    <div class="printlogo">
                                        <img src={FinxPayLogo} alt="logo" />
                                    </div>
                                    <table class="table table-striped table-bordered" border="1" border-collapse>
                                        <tbody>
                                            <tr>
                                                <td>Payment Status:</td>
                                                <td><strong>{this.state.paymentStatus}</strong></td>
                                            </tr>




                                            <tr>
                                                <td>Transfer Amount:</td>
                                                <td>₹ {this.state.transferredAmount}</td>
                                            </tr>
                                            <tr>
                                                <td>Comission:</td>
                                                <td>₹ {this.state.surcharge}</td>
                                            </tr>


                                            <tr>
                                                <td>Total Amount:</td>
                                                <td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <td>Order Id:</td>
                                                <td>{this.state.orderId}</td>
                                            </tr>

                                            <tr>
                                                <td>Date:</td>
                                                <td>{this.state.createdOn}</td>
                                            </tr>

                                        </tbody>
                                    </table>

                                    {this.state.txnSubOrder != '' &&

                                        <table class="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td colspan="3">Sub Transactions Details:</td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td>Transactions ID</td>
                                                    <td>Amount</td>
                                                    <td>Status</td>
                                                    <td>Payment Ref.</td>
                                                </tr>

                                                {this.state.txnSubOrder.map(txRsp => (

                                                    <tr>
                                                        <td>{txRsp.id}</td>
                                                        <td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
                                                        <td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
                                                            txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
                                                        <td>
                                                            {txRsp.paymentRefId}
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table>
                                    }


                                </div>
                            </div>
                            <div class="modal-footer mdftr">
                                <button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, agentInfo, token },
        rechargeReduce: { rechargeTxnHistory, rechargeType } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token,
    rechargeTxnHistory, rechargeType
});

export default connect(mapStateToProps, null)(TxnHistory);
